import React, { useState } from "react";
import { ChevronDown, ChevronRight, FileText } from "lucide-react";

function labelFor(q, val) {
  if (val == null || val === "" || (Array.isArray(val) && val.length === 0)) return null;
  const opts = Object.fromEntries((q?.options || []).map((o) => [o.value, o.label]));
  if (Array.isArray(val)) return val.map((v) => opts[v] || v).join(", ");
  return opts[val] || val;
}

// Read-only, collapsible reference to the client's submitted assessment answers.
// Uses the existing workspace data (no duplicate copy, no new storage).
export default function AssessmentReference({ ws }) {
  const [open, setOpen] = useState(false);
  const session = ws.intake;
  const answers = session?.answers || {};
  const sections = ws.questions?.sections || [];
  const questions = ws.questions?.questions || [];
  const answered = questions.filter((q) => answers[q.id] != null && answers[q.id] !== "");
  if (!session || answered.length === 0) return null;

  const bySection = sections
    .map((s) => ({ s, items: answered.filter((q) => q.section === s.key) }))
    .filter((g) => g.items.length);

  return (
    <div className="lr-card overflow-hidden" data-testid="assessment-reference">
      <button onClick={() => setOpen((v) => !v)} data-testid="assessment-reference-toggle"
        className="w-full flex items-center justify-between p-4 text-left hover:bg-lr-olive/5 transition-colors">
        <span className="flex items-center gap-2 font-serif text-lg text-lr-charcoal">
          <FileText className="h-4 w-4 text-lr-clay" /> From the Assessment
        </span>
        <span className="flex items-center gap-2 text-xs text-lr-leather">
          <span className="px-1.5 py-0.5 rounded-[3px] bg-lr-leather/12 tracking-wide">CLIENT REPORTED</span>
          {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-5 max-h-[440px] overflow-y-auto lr-scroll border-t hairline pt-4" data-testid="assessment-reference-body">
          {bySection.map(({ s, items }) => (
            <div key={s.key} data-testid={`assessment-ref-section-${s.key}`}>
              <div className="text-xs uppercase tracking-wide text-lr-clay mb-2">{s.title}</div>
              <div className="space-y-2.5">
                {items.map((q) => (
                  <div key={q.id} className="text-sm">
                    <div className="text-lr-leather">{q.prompt}</div>
                    <div className="text-lr-charcoal mt-0.5 whitespace-pre-wrap">{labelFor(q, answers[q.id])}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
